import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
{
    id: "po-06-h1v5-01",
    name: "PO 01 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 64, y: 140, width: 441, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 477, width: 142, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 214, y: 477, width: 142, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 364, y: 477, width: 141, height: 236, rotation: 0, imageRotation: 0 },
            { id: "5", x: 622, y: 251, width: 227, height: 352, rotation: 0, imageRotation: 0 },
            { id: "6", x: 857, y: 251, width: 226, height: 352, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h1v5-02",
    name: "PO 02 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 126, y: 161, width: 317, height: 532, rotation: 0, imageRotation: 0 },
        { id: "2", x: 609, y: 161, width: 155, height: 262, rotation: 0, imageRotation: 0 },
        { id: "3", x: 609, y: 431, width: 155, height: 262, rotation: 0, imageRotation: 0 },
        { id: "4", x: 772, y: 431, width: 155, height: 262, rotation: 0, imageRotation: 0 },     
        { id: "5", x: 772, y: 161, width: 318, height: 262, rotation: 0, imageRotation: 0 },
        { id: "6", x: 935, y: 431, width: 155, height: 262, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "hs-06-h1v5-03",
    name: "HS 03 - H1V5",
    albumType: "HS",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 125, y: 161, width: 155, height: 272, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 161, width: 154, height: 272, rotation: 0, imageRotation: 0 },
        { id: "3", x: 125, y: 441, width: 317, height: 253, rotation: 0, imageRotation: 0 },
        { id: "4", x: 610, y: 161, width: 318, height: 532, rotation: 0, imageRotation: 0 },
        { id: "5", x: 936, y: 161, width: 156, height: 262, rotation: 0, imageRotation: 0 },
        { id: "6", x: 936, y: 431, width: 156, height: 262, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-04",
    name: "PO 04 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 60, y: 183, width: 444, height: 306, rotation: 0, imageRotation: 0 },
        { id: "2", x: 60, y: 496, width: 105, height: 176, rotation: 0, imageRotation: 0 },
        { id: "3", x: 173, y: 496, width: 105, height: 176, rotation: 0, imageRotation: 0 },
        { id: "4", x: 286, y: 496, width: 105, height: 176, rotation: 0, imageRotation: 0 },
        { id: "5", x: 399, y: 496, width: 105, height: 176, rotation: 0, imageRotation: 0 },
        { id: "6", x: 705, y: 183, width: 294, height: 489, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-05",
    name: "PO 05 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 47, y: 221, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 431, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "3", x: 175, y: 221, width: 537, height: 412, rotation: 0, imageRotation: 0 },
        { id: "4", x: 720, y: 221, width: 240, height: 412, rotation: 0, imageRotation: 0 },
        { id: "5", x: 968, y: 221, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "6", x: 968, y: 431, width: 120, height: 202, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-06",
    name: "PO 06 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 47, y: 221, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 431, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "3", x: 175, y: 221, width: 537, height: 412, rotation: 0, imageRotation: 0 },
        { id: "4", x: 720, y: 221, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "5", x: 720, y: 431, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "6", x: 848, y: 221, width: 240, height: 412, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-06-h1v5-07",
    name: "PO 07 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 47, y: 221, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 431, width: 120, height: 202, rotation: 0, imageRotation: 0 },
        { id: "3", x: 175, y: 221, width: 119, height: 202, rotation: 0, imageRotation: 0 },
        { id: "4", x: 175, y: 431, width: 119, height: 202, rotation: 0, imageRotation: 0 },
        { id: "5", x: 302, y: 221, width: 537, height: 412, rotation: 0, imageRotation: 0 },
        { id: "6", x: 847, y: 221, width: 241, height: 412, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-08",
    name: "PO 08 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 254, width: 195, height: 347, rotation: 0, imageRotation: 0 },
        { id: "2", x: 203, y: 254, width: 194, height: 347, rotation: 0, imageRotation: 0 },
        { id: "3", x: 405, y: 254, width: 426, height: 347, rotation: 0, imageRotation: 0 },
        { id: "4", x: 839, y: 254, width: 193, height: 347, rotation: 0, imageRotation: 0 },      
        { id: "5", x: 1040, y: 254, width: 96, height: 170, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1040, y: 432, width: 96, height: 169, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-09",
    name: "PO 09 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 35, y: 138, width: 169, height: 285, rotation: 0, imageRotation: 0 },
        { id: "2", x: 35, y: 431, width: 169, height: 285, rotation: 0, imageRotation: 0 },
        { id: "3", x: 212, y: 138, width: 769, height: 578, rotation: 0, imageRotation: 0 },
        { id: "4", x: 989, y: 138, width: 112, height: 188, rotation: 0, imageRotation: 0 },
        { id: "5", x: 989, y: 334, width: 112, height: 187, rotation: 0, imageRotation: 0 },
        { id: "6", x: 989, y: 529, width: 112, height: 187, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-10",
    name: "PO 10 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 43, y: 163, width: 653, height: 527, rotation: 0, imageRotation: 0 },
        { id: "2", x: 704, y: 163, width: 191, height: 313, rotation: 0, imageRotation: 0 },
        { id: "3", x: 903, y: 163, width: 190, height: 313, rotation: 0, imageRotation: 0 },
        { id: "4", x: 704, y: 484, width: 125, height: 206, rotation: 0, imageRotation: 0 },
        { id: "5", x: 837, y: 484, width: 124, height: 206, rotation: 0, imageRotation: 0 },
        { id: "6", x: 969, y: 484, width: 124, height: 206, rotation: 0, imageRotation: 0 }
    ],
}
];